/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NonApprovedSubjectReportRowDTO
 */
export interface NonApprovedSubjectReportRowDTO {
    /**
     * 
     * @type {string}
     * @memberof NonApprovedSubjectReportRowDTO
     */
    programName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NonApprovedSubjectReportRowDTO
     */
    facultyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NonApprovedSubjectReportRowDTO
     */
    domainName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NonApprovedSubjectReportRowDTO
     */
    planCadru?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NonApprovedSubjectReportRowDTO
     */
    disciplineName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NonApprovedSubjectReportRowDTO
     */
    disciplineCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NonApprovedSubjectReportRowDTO
     */
    studyYear?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NonApprovedSubjectReportRowDTO
     */
    semester?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NonApprovedSubjectReportRowDTO
     */
    status?: string | null;
}

export function NonApprovedSubjectReportRowDTOFromJSON(json: any): NonApprovedSubjectReportRowDTO {
    return NonApprovedSubjectReportRowDTOFromJSONTyped(json, false);
}

export function NonApprovedSubjectReportRowDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): NonApprovedSubjectReportRowDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'programName': !exists(json, 'programName') ? undefined : json['programName'],
        'facultyName': !exists(json, 'facultyName') ? undefined : json['facultyName'],
        'domainName': !exists(json, 'domainName') ? undefined : json['domainName'],
        'planCadru': !exists(json, 'planCadru') ? undefined : json['planCadru'],
        'disciplineName': !exists(json, 'disciplineName') ? undefined : json['disciplineName'],
        'disciplineCode': !exists(json, 'disciplineCode') ? undefined : json['disciplineCode'],
        'studyYear': !exists(json, 'studyYear') ? undefined : json['studyYear'],
        'semester': !exists(json, 'semester') ? undefined : json['semester'],
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}

export function NonApprovedSubjectReportRowDTOToJSON(value?: NonApprovedSubjectReportRowDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'programName': value.programName,
        'facultyName': value.facultyName,
        'domainName': value.domainName,
        'planCadru': value.planCadru,
        'disciplineName': value.disciplineName,
        'disciplineCode': value.disciplineCode,
        'studyYear': value.studyYear,
        'semester': value.semester,
        'status': value.status,
    };
}

